(async () => {
  const { Core } = await importModule("Core");
  const { $clone } = await importModule("Utils");

  const SEL_INPUT = "[data-input]";

  customElements.define(
    'product-qty-selector',
    class extends Core {
      elements = {
        selector: "[data-selector-wrapper]",
        inputTemplate: "[data-input-template]",
      };
      render() {
        if (this.querySelector(SEL_INPUT)) this._addButtonListeners();
        this.$selector?.addEventListener("change", this._onQtyChange.bind(this));
      }
      _addButtonListeners() {
        const increaseButton = this.querySelector('.increase-button');
        const decreaseButton = this.querySelector('.decrease-button');
        const input = this.querySelector(SEL_INPUT);

        increaseButton?.addEventListener('click', () => this._changeQuantity(input, 1));
        decreaseButton?.addEventListener('click', () => this._changeQuantity(input, -1));
      }
      _changeQuantity(input, delta) {
        if (!input) return;
        const currentValue = parseInt(input.value);
        const newValue = currentValue + delta;
        const maxValue = parseInt(input.getAttribute('max')) || Infinity;
        const minValue = parseInt(input.getAttribute('min')) || 1;

        if (newValue >= minValue && newValue <= maxValue) {
          input.value = newValue;
        }
      }
      _onQtyChange(e) {
        if (+e.target.value === 10) this._changeInputType();
      }
      _changeInputType() {
        this.replaceChild($clone(this.$inputTemplate), this.$selector);
        this.querySelector(SEL_INPUT).setAttribute("value", 10);
      }
    }
  );

})();
